import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {StorageService} from '../../../services/storage.service';
import {DomainAccess} from '../../../models/user.model';

export interface DomainPickerDialogData {
  domains: DomainAccess[];
  currentDomain: string;
  defaultDomain: string;
}

@Component({
  selector: 'app-domain-picker-dialog',
  templateUrl: './domain-picker-dialog.component.html',
  styleUrls: ['./domain-picker-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DomainPickerDialogComponent {
  selectedDomain: string;

  constructor(
    private dialogRef: MatDialogRef<DomainPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: DomainPickerDialogData,
    private storageService: StorageService
  ) {
    this.selectedDomain = data.currentDomain;
  }

  get isUnchanged(): boolean {
    return this.selectedDomain === this.data.currentDomain;
  }

  apply(): void {
    this.storageService.setDomain(this.selectedDomain);
    this.dialogRef.close();
    this.reload();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  protected reload(): void {
    window.location.reload();
  }
}
